<template>
  <div class='modal-vip pof w100 h100 t0 l0 zi1000 flex aic jcc lh1' v-if="isShow">
    <div class="header bsb por ovh" v-if="showType === 'content'">
      <div class="poa close csp vip-icon close_icon zi1" @click="changeClose"></div>
      <!-- vip弹窗内容 -->
      <template v-if="type === 'vip'">
        <div class="info por">
          <div class="info-box flex aic por">
            <img v-df-avatar :src="userInfo.icon" alt="" class="user-icon">
            <div class="" v-if="userInfo.uid">
              <p class="pb15">
                <span class="fs16 user-name" v-show="userInfo.nickname">{{userInfo.nickname}}</span>
                <span class="fs12 user-text">账号ID：{{userInfo.username}}</span>
                <span class="fs12 user-text pl10" v-show="userInfo.phone">({{userInfo.phone}})</span>
              </p>
              <div v-if="payVipList.length" class="flex aic">
                <p class="f_color csp" @click="clickEvent('vip')"><span class="vam">{{payVipList[0].name}}</span><span class="vip-icon right_arrow"></span>
                </p>
                <p class="f_color fs12 vip-time">{{Tools.formatDate(payVipList[0].end_time,
                'Y年M月D日')}}到期，购买后有效期将顺延</p>
              </div>
              <p v-else class="f_color">您还不是会员</p>
            </div>
            <div v-else>
              <p class="fs16 csp" @click="clickEvent('login')">立即登录</p>
            </div>
          </div>
          <div class="fun-box poa flex aic zi10">
            <p v-for="(item,i) in funList" :key="i" class="fun-text mr10 csp fs12 f_color fun-vip" @click="clickEvent(item.prop)">{{item.label}}</p>
            <poptip-item :item="{name:'联系客服',type:'kf'}" placement="bottom-end" class="csp"></poptip-item>
          </div>
          <p class="fs12 tip">提示：下面各个APP的会员互不通用哦~</p>
          <div class="tab poa b0 l0 flex aic">
            <div v-for="(item,i) in tabList" :key="i" class="tab-item flex-col aic jcc csp" :class="[item.className,tabValue === item.prop ? 'tab-active zi1': '']" @click="changeTab(item)">
              <p class="fs18 tab-label">{{item.label}}</p>
              <p class="fs12 tab-desc">{{item.desc}}</p>
            </div>
          </div>
        </div>
        <div class="content flex">
          <div class="content-list">
            <div class="content-item flex-col aic jcc por csp" v-for="(item,i) in vipList" :key="i" @click="changeVip(item)" :class="{'content-active': vipInfo.id === item.id}">
              <p class="content-name fs24">{{item.name}}</p>
              <p class="content-price">
                <span class="font_bold fs16">￥</span><span class="fs20">{{item.real_price}}</span>
                <s class="content-real pl10">￥{{(+item.real_price !== +item.price) ? item.price : item.cost_price}}</s>
              </p>
              <p class="content-remark">{{item.now_remark}}</p>
              <div class="discount poa l0 t0" v-if="(+item.real_price !== +item.price)" :class="item.discount ? 'discount-zk' : 'discount-lj'">
                <p v-if="item.discount">限时{{item.discount * 10}}折</p>
                <p v-else>限时立减￥{{(item.price - item.real_price).toFixed(2)}}</p>
              </div>
            </div>
          </div>
          <div class="gift por ovh zi1" v-if="giftInfo">
            <template v-if="giftInfo.gift_type === 2">
              <!-- 礼品图 -->
              <div class="w100 h100" :style="`background:url(${giftInfo.bgimg}) no-repeat top left / 100% 100%`">
                <Carousel v-model="imgIndex" :arrow="giftInfo.img.length > 1 ? 'hover' : 'never'" :dots="giftInfo.img.length > 1 ? 'inside ' : 'none'" class="gift-imgs poa b0 l0">
                  <CarouselItem v-for="(img,i) in giftInfo.img" :key="i">
                    <img :src="img" alt="" class="gift-imgs">
                  </CarouselItem>
                </Carousel>
              </div>
            </template>
            <template v-else-if="giftInfo.gift_type === 1">
              <!-- 礼品视频 -->
              <div class="w100 h100 por" @mousemove="isShowTool = true" @mouseleave="isShowTool = false" :style="`background:url(${giftInfo.bgimg}) no-repeat top left / 100% 100%`">
                <video :src="giftInfo.video" class="w100 poa b0 l0" autoplay loop ref="video" @play="playVideo"></video>
                <div v-show="isShowTool" class="vip-icon video-tool poa csp" :class="isPlay ? 'pause_icon' : 'play_icon'" @click="changeVideo"></div>
              </div>
            </template>
            <!-- 默认礼品图 -->
            <img :src="giftInfo.gift_type === 3 ? giftInfo.bgimg : giftInfo.default_gift_img" alt="" class="w100 h100" v-else>
          </div>
        </div>
      </template>
      <!-- 付费课程 -->
      <template v-else-if="type === 'pay'">
        <modal-pay :courseInfo="courseInfo" :vipInfo="vipInfo" :checked="checked" :activity_time="activity_time" @click-checked="changeCheck"></modal-pay>
      </template>
      <div class="pay flex aic">
        <div class="pay-btn">
          <p v-for="(item,i) in btnList" :key="i" class="pay-item flex aic jcc csp" :class="[payType === item.prop ? `pay-active pay-${item.prop}` : '', {'pay-click': !checkVip }]"
            @click="changePayType(item)">
            <span class="vip-icon" :class="item.icon"></span><span>{{item.label}}</span>
          </p>
        </div>
        <div class="pay-qrcode ovh por">
          <img :src="qrCodeImg" alt="" class="w100">
          <div class="poa t0 l0 pay-qrcode-mark w100 h100 flex aic jcc tac" v-if="!checkVip">
            <p class="fs12 pay-qrcode-text">请查阅并勾选右侧 《会员付费协议》</p>
          </div>
        </div>
        <div class="">
          <template v-if="type ==='pay'">
            <p class="need-pay">需支付</p>
            <p class="pay-price fs20" v-html="coursePrice"></p>
          </template>
          <p v-else class="pay-price fs20">￥{{vipInfo.real_price}}</p>
          <div class="pay-agree flex aic csp" @click="checkVip = !checkVip">
            <i class="vip-icon" :class="checkVip ? 'check_icon' : 'no_check_icon'"></i>
            <p class="pl5 fs12">我已阅读并接受<span class="pay-agree-vip" @click.stop="clickEvent('agree')">《会员付费协议》</span></p>
          </div>
        </div>
      </div>
      <p class="fs12 tac footer">*会员服务属于虚拟业务，自行开通成功后不支持退换，敬请谅解</p>
    </div>
    <div v-else-if="showType === 'success'" class="success por">
      <div class="poa csp vip-icon close_success_icon zi1" @click="changeSuccess"></div>
      <div class="flex-col aic jcc success-content">
        <div class="vip-icon success_icon"></div>
        <p class="fs16 success-text">支付成功</p>
        <p class="fs12 success-tip">关注公众号获取更多相关课程</p>
        <img :src="kfInfo.wx_code" alt="" class="success-img">
      </div>
    </div>
    <div class="close-content zi10 poa w100 h100 flex aic jcc" v-if="isClose">
      <div class="close-box por">
        <img src="@/assets/images/vip/close.png" alt="" class="w100">
        <div class="close-btn poa flex aic">
          <p class="close-leave csp tac" @click="isShow = false">狠心离开</p>
          <p class="close-look csp tac" @click="isClose = false">再看看</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ModalVip',
  props: {
    type: {
      type: String,
      default: 'vip'
    },
    cid: {
      type: Number | String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    dfSelect: {
      type: String,
      default: 'tb',
    },
  },
  data () {
    return {
      funList: [
        { label: '兑换会员', prop: 'exchange' },
        { label: '了解所有VIP特权', prop: 'privilege' },
      ],
      tabList: [
        { label: '同步小学课堂VIP', prop: 'tb', product_id: 1, desc: '适用人群：小学1-6年级', className: 'left-icon' },
        { label: '格灵课堂VIP', prop: 'gl', product_id: 13, desc: '适用人群：学前、小学、初中、高中、家长', className: 'right-icon' },
      ],
      btnList: [
        { label: '微信支付', prop: 'wx', icon: 'wx_icon' },
        { label: '支付宝支付', prop: 'zfb', icon: 'zfb_icon' },
      ],
      tabValue: 'tb',
      currProduct: 1, // 当前选择的产品id
      isShow: true,
      showType: 'content', // 显示类型
      vipList: [],
      giftList: [],
      vipInfo: {},
      payType: 'wx',
      qrCodeImg: '', // 支付二维码
      imgIndex: 0,
      order_timer: null, // 查询订单计时器
      wxQRcode: '', // 公众号二维码
      isChecked: false,
      courseInfo: {},
      coursePrice: '', // 课程总价格
      activity_time: '',
      isClose: false,
      isPlay: false,
      isShowTool: false,
      payVipList: [],
      checkVip: true,
      payQRList: {
        wx: {},
        zfb: {}
      },
      isResQr: false,
			orderList:[],//正在轮询的订单列表
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'allGrades', 'showClose', 'isShowPayPopup', 'kfInfo']),
    giftInfo () {
      let info = {};
      if (this.giftList && this.giftList.length) {
        info = this.giftList.find(e => +e.vip_id === this.vipInfo.id);
      } else {
        info = this.vipList.find(e => +e.id === this.vipInfo.id);
      }
      return info;
    },
    getPayPrice () {
      return (bool) => {
        let { userInfo, vipInfo, courseInfo } = this;
        let text = "";
        let all_prcie = '';
        if (bool) {
          all_prcie = +courseInfo.vip_price && +vipInfo.real_price ? (+courseInfo.vip_price + +vipInfo.real_price).toFixed(2) : 0;
          text = `￥${all_prcie} <span class="fs14">= 课程￥${courseInfo.vip_price} + 年卡￥${vipInfo.real_price || 0}</span>`;
        } else {
          text = `￥${courseInfo.price || 0}`;
        }
        return text;
      }
    },
  },
  watch: {
    isShow (val) {
      if (!val) {
        this.setIsShowPayPopup(false);
        clearTimeout(this.order_timer);
        this.order_timer = null;
				this.orderList = []
      }
    },
    isChecked (bool) {
      this.coursePrice = this.getPayPrice(bool);
      this.getPayQRcode();
    },
    dfSelect (val) {
			if(this.userInfo.uid){
				this.changeTab({ prop: val, product_id: val === 'tb' ? 1 : 13 });
			}
    },
    'vipInfo.real_price': {
      handler (val) {
        if (val && this.isChecked && this.type === 'pay') {
          this.coursePrice = this.getPayPrice(true);
        }
      }
    }
  },
  created () {
    if (!this.userInfo.uid) {
      this.ToLogin();
      return this.isShow = false;
    }
    this.$nextTick(() => {
      if (this.type === 'pay') {
        this.currProduct = this.allGrades.find(e => +e.pid === 2 && e.id === +this.userInfo.nianji_id) ? 1 : 13;
        this.getCourseInfo();
      }
      this.getVipList();
      this.getMyVip();
    })
  },
  mounted () { 
	},
  methods: {
    ...mapMutations(['setShowClose', 'setIsShowPayPopup']),

    // 获取课程
    getCourseInfo () {
      let params = {
        uid: this.userInfo.uid,
        course_id: this.cid,
        ...this.Product,
        channel_type: 2,
      }
      this.http.getResourceList(params).then(res => {
        this.courseInfo = res;
        this.coursePrice = `￥${this.userInfo.is_web_vip ? res.vip_price : res.price}`;
        if (res.activity_data && res.activity_data.surplus_time && res.is_activity) {
          this.ActivityCountDown(res.activity_data.surplus_time * 1000, { key: 'activity_time', format: 'DD : HH : mm : ss', style: 'background:rgba(51, 51, 66, 0.5);width: 18px;line-height: 18px;display: inline-block;text-align: center;' }, () => { this.getCourseInfo();this.getPayQRcode();this.activity_time = ''; });
        }
      }).catch(console.log);
    },
    changeSuccess () {
      this.isShow = false;
      location.reload();
    },
    // 控制视频
    changeVideo () {
      this.isPlay = !this.isPlay;
      let video = this.$refs.video;
      this.isPlay ? video.play() : video.pause();
    },
    playVideo (e) {
      this.isPlay = true;
    },
    // 关闭弹窗
    changeClose () {
      if (!this.showClose) {
        this.isClose = true;
        this.setShowClose(true);
      } else {
        this.isShow = false;
        this.payQRList = { wx: {}, zfb: {} };
				this.orderList = [];
      }
    },
    // 付费课程选中会员
    changeCheck (bool) {
      this.isChecked = bool;
    },
    // 获取VIP套餐列表
    getVipList () {
      let params = {
        uid: this.userInfo.uid,
        ...this.Product,
        product_id: this.currProduct,
        channel_type: 2,
      };
      this.http.NEWGetVipList(params, { needCancel: 'url' }).then(res => {
        if (this.type === 'vip') {
					//前端在name中没有卡字的后面补卡字
          this.vipList = res.price_list.map((e) => { 
						e.name = e.name.indexOf('卡') < 0? e.name+'卡' : e.name
						return e
					});;
          this.vipInfo = res.price_list.find(e => e.is_recommend === 1);
          this.giftList = res.activity_access.give_gift;
        } else {
          this.vipInfo = res.price_list.find(e => e.name === '年');
        }
        this.getPayQRcode();
      }).catch(this.$err);
    },
    // 获取我的会员
    getMyVip () {
      this.http.NEWVipList({ uid: this.userInfo.uid }).then(res => {
        this.payVipList = res.list;
      }).catch(console.log);
    },
    // 获取支付二维码
    getPayQRcode (prop) {
      if (prop) {
        let item = this.payQRList[this.payType];
        if (item && item.out_trade_no) {
          this.qrCodeImg = item.pay_url;
          this.queryOrder(item.out_trade_no);
          return
        }
      }
      let params = {
        uid: this.userInfo.uid,
        ...this.Product,
        product_id: this.type === 'vip' || (this.type ==='pay'&& this.isChecked)  ? this.currProduct : this.Product.product_id,
        type: this.type === 'vip' ? 1 : this.isChecked ? 4 : 2,
        channel_type: 2,
        order_type: this.type === 'vip' || (this.type ==='pay'&& this.isChecked)  ? this.vipInfo.id : '',
        course_id: this.cid,
				type_id:this.payType === 'wx' ? 1 : 2,
        is_web: 1,
      };
      let url = this.payType === 'wx' ? 'NEWWxPay' : 'NEWZfbPay';
      this.isResQr = true;
			// console.log(params)
      this.http[url](params).then(res => {
        this.qrCodeImg = res.pay_url;
				this.orderList.push(res.out_trade_no)
        this.queryOrder();
        this.payQRList[this.payType] = res;
      }).catch((err)=>{
				this.$err(err)
			}).finally(()=>{ this.isResQr = false; });
    },
    // 支付订单查询
    queryOrder () {
			let order = this.orderList.join(',')
      // let url = this.payType === 'wx' ? 'NEWWxQueryOrder' : 'NEWZfbQueryOrder';
			let url = 'NEWOrderQueryOrder'
      this.http[url]({ out_trade_no: order }).then(res => {
        clearTimeout(this.order_timer);
        this.order_timer = null;
        this.showType = 'success';
        this.$emit('pay-success');
      }).catch(err => {
        console.log(err);
        if (err.code * 1 === 20040 && this.isShow) {
          if (this.order_timer) {
            clearTimeout(this.order_timer);
            this.order_timer = null;
          }
          this.order_timer = setTimeout(() => {
            this.queryOrder();
          }, 1000)
        }
      })
    },
    // 选择支付方式
    changePayType (item) {
      // if (!this.checkVip) { return; }
      if(this.isResQr){
        return this.ShowToast('当前切换频率太快，请稍后');
      }
      this.payType = item.prop;
      this.getPayQRcode(1);
    },
    // 选择VIP
    changeVip (item) {
      this.vipInfo = item;
      this.imgIndex = 0;
      this.getPayQRcode();
    },
    // 选择产品
    changeTab (item) {
      this.tabValue = item.prop;
      this.currProduct = item.product_id;
      this.getVipList();
    },
    // 点击跳转
    clickEvent (prop) {
      switch (prop) {
        case 'login':
          this.ToLogin();
          this.isShow = false;
          break;
        case 'exchange':
          this.OpenRouter('/user/vip/exchange');
          break;
        case 'privilege':
          this.OpenRouter('/user/remark');
          break;
        case 'agree':
          this.OpenRouter('/footer/details?type=vip_protocol');
          break;
        case 'vip':
          this.OpenRouter('/user/vip/my');
          break;
      }
    }
  }
}
</script>

<style scoped lang='less'>
@import '../../assets/less/function';

.vip-icon {
  .spirit(url(../../assets/images/vip_icon.png));
  &.check_icon {
    &:after {
      width: 16px;
      height: 16px;
      background-position: -188px -85px;
    }
  }
  &.no_check_icon {
    &:after {
      width: 16px;
      height: 16px;
      background-position: -168px -85px;
    }
  }
  &.close_icon {
    &:after {
      width: 19px;
      height: 20px;
      background-position: -179px -1px;
    }
  }
  &.close_success_icon {
    top: 9px;
    right: 8px;
    &:after {
      width: 24px;
      height: 24px;
      background-position: -63px -104px;
    }
  }
  &.success_icon {
    &:after {
      width: 56px;
      height: 56px;
      background-position: -2px -104px;
    }
  }
  &.right_arrow {
    margin-left: 8px;
    &:after {
      width: 7px;
      height: 12px;
      background-position: -92px -74px;
    }
  }
  &.wx_icon {
    margin-right: 7px;
    &:after {
      width: 20px;
      height: 20px;
      background-position: -23px -38px;
    }
  }
  &.wx_icon_active {
    &:after {
      background-position: -1px -38px;
    }
  }
  &.zfb_icon {
    margin-right: 7px;
    &:after {
      width: 20px;
      height: 20px;
      background-position: -45px -38px;
    }
  }
  &.zfb_icon_active {
    &:after {
      background-position: -67px -38px;
    }
  }
  &.play_icon {
    &:after {
      width: 40px;
      height: 40px;
      background-position: -45px -61px;
    }
  }
  &.pause_icon {
    &:after {
      width: 40px;
      height: 40px;
      background-position: -2px -61px;
    }
  }
}

.modal-vip {
  background: rgba(0, 0, 0, 0.7);
}

.header {
  width: 880px;
  // height: 657px;
  background: linear-gradient(180deg, transparent 10px, #f6f6f6 10px);
  border-radius: 10px;
  .close {
    top: 8px;
    right: 12px;
  }
  .info {
    height: 167px;
    background: url(../../assets/images/vip/header_vip.png) no-repeat top left /
      100% 100%;
    &-box {
      padding: 18px 18px 16px;
      color: #fff;
    }
  }
  .user-icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin-right: 16px;
  }
  .user-name {
    padding-right: 16px;
  }
  .user-text {
    color: rgba(255, 255, 255, 1);
  }
  .vip-time {
    padding-left: 18px;
    opacity: 0.7;
  }
  .fun-box {
    top: 51px;
    right: 17px;
    color: rgba(255, 255, 255, 0.8);
    /deep/ .poptip-item {
      .item-name {
        font-size: 12px;
      }
    }
    /deep/ .ivu-poptip-arrow:after {
      border-bottom-color: #1177ff;
    }
  }
  .fun-vip {
    padding-right: 10px;
    border-right: 1px solid #ffffff;
  }
  .tip {
    color: rgba(255, 255, 255, 0.7);
    padding-left: 18px;
  }
  .tab {
    .left-icon {
      mask: url(../../assets/images/vip/tab_left.png) no-repeat;
      background: linear-gradient(270deg, #28303a, #18212c);
    }
    .right-icon {
      transform: translateX(-12px);
      mask: url(../../assets/images/vip/tab_right.png) no-repeat;
      background: linear-gradient(90deg, #28303a, #18212c);
    }
    &-item {
      width: 446px;
      height: 62px;
      mask: url(../../assets/images/vip/tab_left.png) no-repeat;
    }
    &-label {
      font-weight: bold;
      color: rgba(255, 255, 255, 0.8);
      padding-bottom: 8px;
    }
    &-desc {
      color: rgba(255, 255, 255, 0.6);
    }
    &-active {
      background: linear-gradient(90deg, #ffe7c2, #ffd28c) !important;
      .tab-label {
        color: #b9732e;
      }
      .tab-desc {
        color: #575757;
      }
    }
  }
  .content {
    &-list {
      padding-left: 66px;
      margin-right: 22px;
    }
    &-item {
      width: 352px;
      height: 117px;
      margin-top: 16px;
      background: #f6f6f6;
      border-radius: 8px;
    }
    &-active {
      background: url(../../assets/images/vip/select_active.png) no-repeat top
        left / 100%;
      .content-name {
        color: #b9732e;
      }
    }
    &-name {
      .font_bold;
      color: #333f4e;
    }
    &-price {
      color: #ed5e10;
      padding: 14px 0;
    }
    &-remark {
      color: #999fa6;
    }
    .discount {
      color: #ffffff;
      padding: 5px 16px;
      border-radius: 10px 0px;
      &-zk {
        background: linear-gradient(90deg, #ff8726 0%, #ff5724 100%);
      }
      &-lj {
        background: linear-gradient(90deg, #ff3b5f 0%, #ff1f48 100%);
      }
    }
  }
  .gift {
    /deep/ .ivu-icon-ios-arrow-back:before {
      font-size: 20px;
    }
    /deep/ .ivu-icon-ios-arrow-forward:before {
      font-size: 20px;
    }
    /deep/ .ivu-carousel-arrow > * {
      vertical-align: -10%;
    }
    margin-top: 16px;
    width: 338px;
    height: 250px;
    &-box {
    }
    &-imgs {
      width: 338px;
      height: 189px;
    }
    /deep/ .ivu-carousel-dots {
      li {
        button {
          background: #fff;
          opacity: 0.6;
          border-radius: 2px;
        }
      }
      .ivu-carousel-active {
        button {
          background: #fff;
          opacity: 1;
        }
      }
    }
    .video-tool {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .pay {
    height: 168px;
    margin: 16px 18px 14px;
    background-color: #fff;
    border-radius: 10px;
    &-click {
      cursor: not-allowed;
    }
    &-btn {
      padding: 40px 72px;
    }
    &-item {
      width: 128px;
      height: 36px;
      background: rgba(0, 194, 80, 0);
      border-radius: 4px;
      color: #6e6e6e;
      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }
    &-active {
      color: #ffffff;
      .wx_icon {
        .vip-icon .wx_icon_active;
      }
      .zfb_icon {
        .vip-icon .zfb_icon_active;
      }
    }
    .pay-wx {
      background: #00c250;
    }
    .pay-zfb {
      background: #1677ff;
    }
    &-qrcode {
      width: 120px;
      height: 120px;
      margin-right: 30px;
      &-mark {
        background: rgba(26, 35, 46, 0.9);
      }
      &-text {
        font-weight: bold;
        color: rgba(255, 255, 255, 0.8);
        line-height: 18px;
      }
    }
    &-price {
      color: #ff2517;
    }
    &-agree {
      color: #aaaaaa;
      padding-top: 17px;
      &-vip:hover {
        color: #1177ff;
      }
    }
    .need-pay {
      color: #666f7a;
      padding-bottom: 14px;
    }
  }
  .footer {
    color: #b6b6b6;
    padding-bottom: 14px;
  }
  .f_color {
    color: #ffd99e;
  }
  .font_bold {
    font-weight: bold;
  }
}

.close {
  &-content {
    background: rgba(0, 0, 0, 0.6);
  }
  &-box {
    width: 292px;
    height: 377px;
  }
  &-btn {
    bottom: 31px;
    left: 41px;
  }
  &-leave {
    width: 88px;
    height: 30px;
    line-height: 30px;
    background: #f7e6cb;
    border: 1px solid #f4472b;
    border-radius: 15px;
    color: #f4472b;
    margin-right: 32px;
  }
  &-look {
    width: 88px;
    height: 30px;
    line-height: 30px;
    background: #f4472b;
    border-radius: 15px;
    color: #ffffff;
  }
}

.success {
  width: 304px;
  height: 349px;
  background: #ffffff;
  border-radius: 8px;
  &-content {
    padding-top: 40px;
  }
  &-text {
    padding: 15px 0 39px;
    color: #333f4e;
  }
  &-tip {
    padding-bottom: 17px;
    color: #999fa6;
  }
  &-img {
    width: 120px;
    height: 120px;
    box-shadow: 0px 5px 11px 0px rgba(0, 15, 34, 0.08);
  }
}
</style>
